import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Resolve } from '@angular/router';
import {
  OFFER_REGEX,
  POSTCODE_REGEX,
  QuoteParamsParserService,
} from '@common/util-foundation';
import {
  OfferFormSubmit,
  ParseResponse,
  ParseResult,
} from '@common/util-models';
import { OfferRenewalLandingPageFacade } from '@oren/data-access-offer-renewal';
import {
  MonoTypeOperatorFunction,
  NEVER,
  Observable,
  of,
  OperatorFunction,
  pipe,
} from 'rxjs';
import { first, map, switchAll, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OfferQueryParamsResolver
  implements Resolve<Observable<ParseResponse<OfferFormSubmit>>> {
  private postCodeValidation = [
    Validators.required,
    Validators.pattern(POSTCODE_REGEX),
  ];

  private referenceNumberValidation = [
    Validators.required,
    Validators.pattern(OFFER_REGEX),
  ];

  constructor(
    private offerRenewalFacade: OfferRenewalLandingPageFacade,
    private quoteParamsParserService: QuoteParamsParserService<OfferFormSubmit>
  ) {}

  resolve(): Observable<ParseResponse<OfferFormSubmit>> {
    return this.quoteParamsParserService
      .parse({
        referenceNumber: this.referenceNumberValidation,
        postCode: this.postCodeValidation,
      })
      .pipe(
        first(),
        this.submitQuoteIfParsingSuccessful(),
        this.waitIfParsingSuccessful()
      );
  }

  private submitQuoteIfParsingSuccessful(): MonoTypeOperatorFunction<
    ParseResponse<OfferFormSubmit>
  > {
    return pipe(
      tap((parsedResponse) => {
        if (
          parsedResponse.result === ParseResult.Success &&
          parsedResponse.model
        ) {
          this.offerRenewalFacade.getEmailOffer(
            parsedResponse.model?.referenceNumber as string,
            parsedResponse.model?.postCode as string
          );
        }
      })
    );
  }

  private waitIfParsingSuccessful(): OperatorFunction<
    ParseResponse<OfferFormSubmit>,
    ParseResponse<OfferFormSubmit>
  > {
    return pipe(
      map((parsedResponse) =>
        parsedResponse.result === ParseResult.Success
          ? NEVER
          : of(parsedResponse)
      ),
      switchAll()
    );
  }
}
